<template>
  <div class="contain mx-auto my-32">
    <!-- <div>
      <p class="breadcrumbs">Dashboard > Navigation > Balloon A</p>
    </div> -->
    <div class="flex justify-between">
      <div class="py-5">
        <p class="text-xl font-bold">Balloon ID: ASNQ11-2DB4-6713</p>
      </div>
      <div>
        <div class="flex justify-center xl:justify-start w-full">
          <button
            class="focus:outline-none text-base font-medium rounded-l-lg p-5 md:py-4 bg-btnGray shadow-xl"
          >
            <router-link to="/streams/a">Stream console</router-link>
          </button>
          <button
            class="bg-buttoncolor rounded-r-lg focus:outline-none text-base font-medium text-white p-5 md:py-4  shadow-xl"
          >
            Navigation console
          </button>
        </div>
      </div>
    </div>

    <div class="flex mt-10">
      <div class="xl:mr-10">
        <img src="@/assets/images/stream2.png" alt="" />
        <div class="mt-10">
          <c-box>
            <c-tabs variant="solid-rounded" is-fitted variant-color="blue">
              <c-tab-list>
                <c-tab>Quick</c-tab>
                <c-tab>Action</c-tab>
                <c-tab>Gauges</c-tab>
                <c-tab>Status</c-tab>
                <c-tab>Telemetry Log</c-tab>
              </c-tab-list>

              <c-tab-panels>
                <c-tab-panel>
                  <div class="p-16">
                    <div class="flex justify-center justify-around my-3">
                      <p class="text-blue text-2xl font-bold">Alt</p>
                      <p class="text-blue text-2xl font-bold">87.35</p>
                    </div>
                    <div class="flex justify-center justify-around my-3">
                      <p class="text-blue text-2xl font-bold">Ground speed</p>
                      <p class="text-yellow-500 text-2xl font-bold">15.35</p>
                    </div>
                    <div class="flex justify-center justify-around my-3">
                      <p class="text-blue text-2xl font-bold">wp_dist</p>
                      <p class="text-red-500 text-2xl font-bold">49</p>
                    </div>
                  </div>
                </c-tab-panel>
                <c-tab-panel>
                  <p>Test2</p>
                </c-tab-panel>
                <c-tab-panel>
                  <p>Test3!</p>
                </c-tab-panel>
                <c-tab-panel>
                  <p>Test4!</p>
                </c-tab-panel>
                <c-tab-panel>
                  <p>Test5!</p>
                </c-tab-panel>
              </c-tab-panels>
            </c-tabs>
          </c-box>
        </div>
      </div>
      <div>
        <img src="@/assets/images/stream1.png" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
import { CTabs, CTabList, CTabPanels, CTab, CTabPanel } from "@chakra-ui/vue";
export default {
  components: {
    CTabs,
    CTabList,
    CTabPanels,
    CTab,
    CTabPanel
  }
};
</script>

<style></style>
